import { TOAST_OPTIONS_MAP } from '../../constants';
import { ToastOptionModel, ToastSeverity } from '../../models';

export const getToastContentBySeverity = (
  severity: ToastSeverity,
  life = 3000,
): ToastOptionModel => ({
  ...TOAST_OPTIONS_MAP[severity],
  life,
});
